module.exports = function() {
  return new Worker(__webpack_public_path__ + "40de49724a2bdfa4e7ce.worker.js");
};